// Port of api/fuel/app/classes/filter/package/games/rating/data/comments.php
import DB from 'offline/db'
import Util from 'offline/util'
export default {
	run: function(filter, data, config, global) {
		if (!global.gameIds || !global.gameIds.length) return
		var rows = DB.query('SELECT game_id, user_id, comment_text, comment_date FROM comment WHERE game_id IN(' + Util.in(global.gameIds) + ') AND user_id IN(' + Util.in(global.userIndex) + ')')
		global.comments = {}
		for (var i = 0; i < rows.length; i++) {
			var comment = {
				user: parseInt(rows[i].user_id || 0, 10),
				date: parseInt(rows[i].comment_date || 0, 10),
				text: String(rows[i].comment_text || '').replace(/\n/g, '<br />\n')
			}

			if (global.ownerType === 1) {
				global.comments[rows[i].game_id] = comment
			} else {
				if (!global.comments[rows[i].user_id]) global.comments[rows[i].user_id] = []
				global.comments[rows[i].user_id].push(Object.assign({ game: parseInt(rows[i].game_id || 0, 10) }, comment))
			}
		}
	}
}
